// extracted by mini-css-extract-plugin
module.exports = {"report-tax":"report-tax_report-tax__ZYkrP","report-tax__amount":"report-tax_report-tax__amount__25Yqo","report-tax__note":"report-tax_report-tax__note__WU2wp"};